import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import cx from "classnames";

import { getModal } from "modules/root/root-selectors";
import ModalActions from "modules/modal/modal-actions";
import ModalRootPortal from "modules/root/modal-root-portal";
import {
  ModalType,
  ModalTypes,
  HelpTextTypes
} from "modules/modal/modal-constants";
import HelpTextModal from "modules/modal/help-text-modal";
import QuestionChangedWarningModal from "modules/modal/question-changed-warning-modal";
import UnexpectedErrorModal from "modules/modal/unexpected-error-modal";
import TempLoginModal from "modules/modal/temp-login-modal";
import ThinkingModal from "modules/modal/thinking-modal";
import ExitDiagnosticModal from "modules/modal/exit-diagnostic-modal";
import ConsentModal from "./consent-modal";
import HumanModal from "./human-modal";

import clinicalEn from "../../common/consents/clinical_info_en_andr";
import clinicalSe from "../../common/consents/clinical_info_swe_andr";

import termsEn from "../../common/consents/terms_of_use_en_andr";
import termsSe from "../../common/consents/terms_of_use_swe_andr";

import privacyEn from "../../common/consents/privacy_policy_en_andr";
import privacySe from "../../common/consents/privacy_policy_swe_andr";

import constants from "../../common/constants";

const stopEventPropagation = ev => ev.stopPropagation();

class Modal extends Component {
  static propTypes = {
    activeModalType: PropTypes.oneOf(ModalTypes),
    onClose: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired
  };

  renderModal = () => {
    const { activeModalType, lang } = this.props;
    if (HelpTextTypes.includes(activeModalType)) {
      return <HelpTextModal type={ModalType.SELF_DIAGNOSIS_SCREEN} />;
    } else if (activeModalType === ModalType.QUESTION_CHANGED_WARNING) {
      return <QuestionChangedWarningModal onClose={this.props.onClose} />;
    } else if (activeModalType === ModalType.UNEXPECTED_ERROR) {
      return <UnexpectedErrorModal onClose={this.props.onClose} />;
    } else if (activeModalType === ModalType.TEMP_LOGIN) {
      return <TempLoginModal onClose={this.props.onClose} />;
    } else if (activeModalType === ModalType.EXIT_DIAGNOSTIC) {
      return <ExitDiagnosticModal onClose={this.props.onClose} />;
    } else if (activeModalType === ModalType.THINKING) {
      return <ThinkingModal />;
    } else if (activeModalType === ModalType.HUMAN_INFO) {
      return <HumanModal onClose={this.props.onClose} />;
    } else if (activeModalType === ModalType.CONSENT_MEDICAL) {
      return (
        <ConsentModal
          onClose={this.props.onClose}
          consentText={
            lang === constants.appLanguages.sv ? clinicalSe : clinicalEn
          }
        />
      );
    } else if (activeModalType === ModalType.CONSENT_TERMS) {
      return (
        <ConsentModal
          onClose={this.props.onClose}
          consentText={lang === constants.appLanguages.sv ? termsSe : termsEn}
        />
      );
    } else if (activeModalType === ModalType.CONSENT_PRIVACY) {
      return (
        <ConsentModal
          onClose={this.props.onClose}
          consentText={
            lang === constants.appLanguages.sv ? privacySe : privacyEn
          }
        />
      );
    }
    return null;
  };
  shoudAdjustMargin() {
    const { activeModalType } = this.props;
    return (
      activeModalType === ModalType.CONSENT_MEDICAL ||
      activeModalType === ModalType.CONSENT_TERMS ||
      activeModalType === ModalType.CONSENT_PRIVACY
    );
  }

  shouldAddCloseButton() {
    const { activeModalType } = this.props;
    return (
      activeModalType === ModalType.CONSENT_MEDICAL ||
      activeModalType === ModalType.CONSENT_TERMS ||
      activeModalType === ModalType.CONSENT_PRIVACY
    );
  }

  render() {
    const { activeModalType, onClose } = this.props;
    const closable = activeModalType !== ModalType.THINKING;
    return (
      activeModalType &&
      activeModalType !== ModalType.TEMP_LOGIN && (
        <ModalRootPortal>
          <div
            className={cx(
              `overlay ${
                HelpTextTypes.includes(activeModalType) ? "help-modal" : ""
              }`,
              `modal--type-${activeModalType}`
            )}
            onClick={() => closable && onClose()}
          >
            <div
              className={`modal ${
                this.shoudAdjustMargin() ? "custom-margin" : ""
              }`}
              onClick={stopEventPropagation}
            >
              {closable && (
                <button
                  className="Button--modalClose"
                  onClick={() => onClose()}
                />
              )}
              {this.renderModal()}

              {this.shouldAddCloseButton() && (
                <div className="next close-consent-button">
                  <button className="Button--round" onClick={() => onClose()}>
                    <FormattedMessage id="consent-modal.i_consent" />
                  </button>
                  <div className="spacer" />
                </div>
              )}
            </div>
          </div>
        </ModalRootPortal>
      )
    );
  }
}

const mapDispatch = {
  onClose: ModalActions.Creators.closeModal
};
export default connect(
  getModal,
  mapDispatch
)(Modal);



// WEBPACK FOOTER //
// ./src/modules/modal/modal.js